import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import { IUPCData, IUPCDataError, UPCRuleType } from "../types";

export class NotEmptyRule extends Validator<IUPCData[], IUPCDataError> {
    validate(rows: IUPCData[], errors: IUPCDataError): IUPCDataError {
        const notEmptyErrorType = UPCRuleType.NotEmptyRule;
        const isFileEmpty = rows.length === 0;

        const validationErrors = !isFileEmpty
            ? errors
            : {
                  ...errors,
                  [notEmptyErrorType]: formatMessage(
                      "No data found. If your file has multiple tabs, please make sure your data is on the first tab."
                  ),
              };

        return super.validate(rows, validationErrors);
    }
}
